import moment from "moment-timezone";

export default {
  props: {
    itemSelected: {
      type: Boolean,
      required: false,
      default: false,
    },
    itemInfo: {
      type: Object,
      required: true,
    },
  },
  computed: {
    localisedDate() {
      let momentLocale = "en";

      switch (this.$i18n.locale) {
        case "tc":
          momentLocale = "zh-HK";
        case "sc":
          momentLocale = "zh-CN";
      }

      moment.locale(momentLocale);
      // Times are given to us in local with Hong Kong timezone attached. We always want
      // to display times in local Hong Kong time. If we don't specify it will convert to
      // the users local browser time.

      if (momentLocale == 'en') {
        return moment(this.itemInfo.showDateTime).tz('Asia/Hong_Kong').format(
          "ddd, DD MMMM YYYY h:mma"
        );
      } else {
        return moment(this.itemInfo.showDateTime).tz('Asia/Hong_Kong').format(
          "dddd, LL, a h:mm"
        );
      }
    },
  },
}